<template>
    <v-dialog max-width="500px" v-model="inDialog" persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-autocomplete
                                    :items="lstCrop"
                                    label="Vụ nuôi"
                                    v-model="item.cropCode"
                                    name="cropCode"
                                    item-value="code"
                                    item-text="code"
                                    data-vv-as="Vụ nuôi"
                                    v-validate="'required'"
                                    :error-messages="errors.first('cropCode')"
                                    clearable
                            />
                        </v-flex>
                        <v-flex xs12>
                            <i-datepicker
                                type="text"
                                label="Ngày ghi chép"
                                v-model.trim="item.noteDate"
                                name="noteDate"
                                v-validate="'required|date_before_now'"
                                :error-messages="errors.first('noteDate')"
                                data-vv-as="Ngày ghi chép"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                :items="lstDisease"
                                label="Tên bệnh"
                                v-model="item.diseaseId"
                                name="diseaseId"
                                item-value="categoryId"
                                item-text="categoryName"
                                data-vv-as="Tên bệnh"
                                v-validate="'required'"
                                clearable
                                :error-messages="errors.first('diseaseId')"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                label="Ghi chép"
                                v-model="item.notes"
                                name="notes"
                                data-vv-as="Ghi chép"
                                :error-messages="errors.first('notes')"
                                maxlength="500"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { areaContants } from "@/constants";
import moment from "moment";

export default {
    name: "note-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        formCreateName: {
            type: String,
            default: '',
        },
        lstDisease: {
            type: Array,
            default:()=>{
                return [];
            }
        },
        lstCrop: {
            type: Array,
            default:()=>{
                return [];
            }
        }
    },
    data: () => {
        return {
            areaStatus: areaContants.areaStatus,
            item: {
                cropCode: null,
                noteDate: new Date(),
                diseaseId:null,
                diseaseName:null,
                notes:null,
                shrimpAge:null,
                numberOfSeed:null,
                status: 1,
            },
            inDialog: false,
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                if (value !== null) {
                    Object.assign(this.item,value);
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.emptyForm();
            this.$validator.reset();
        },
        onCancel: function () {
            this.emptyForm();
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                for(let i=0;i<this.lstDisease.length;i++){
                    if(this.lstDisease[i].categoryId == this.item.diseaseId){
                        this.item.diseaseName = this.lstDisease[i].categoryName;
                        break;
                    }
                }
                for(let i=0;i<this.lstCrop.length;i++) {
                    if(this.lstCrop[i].code == this.item.cropCode) {
                        this.item.shrimpAge = this.shrimpAgeByDate(this.lstCrop[i],this.item.noteDate);
                        this.item.numberOfSeed = this.lstCrop[i].seedNumber;
                        break;
                    }
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                            "/cropNotes/save",
                        this.item
                    )
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                let msg = data.description;
                                message.error(this.$t(msg));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        emptyForm () {
            this.item = {
                cropCode: null,
                noteDate: new Date(),
                diseaseId:null,
                diseaseName:null,
                notes:null,
                shrimpAge:null,
                numberOfSeed:null,
                status: 1,
            };
        },

        shrimpAgeByDate(item, calculateDate) {
            let shrimpAge = 0;
            let dropDate = '';
            if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                dropDate = moment(String(item.dropDateParent));
            } else if (item.dropDate != '' && item.dropDate != null) {
                dropDate = moment(String(item.dropDate));
            }
            //console.log(dropDate);
            if (dropDate != '') {
                let calculateDateMM = moment(String(calculateDate));
                let endDate = moment(String(calculateDate));
                if (item.endDate) {
                    endDate = moment(String(item.endDate));
                    if (endDate > calculateDateMM) endDate = calculateDateMM;
                }
                //if (endDate > dropDate) {
                let dates = endDate.diff(dropDate, "days");
                //console.log(endDate);
                //console.log(dates);
                /*
                                    if (dates < 0) {
                                        console.log("less than 0:" + dates);
                                    }
                                    if (dates >= 0) {
                                    }
                */
                shrimpAge = dates;
                //}
            }
            return shrimpAge;

        },

    },
    created() {},
};
</script>
